import { DataEventProp } from 'approot/shared/data-tracker/data-tracker.constants';
import { LanguageCodes } from 'global/constants';

export type TabOption = {
  label: string;
  value: string | number;
  isDisabled?: boolean;
  language?: LanguageCodes;
};

export type Props = {
  options: TabOption[];
  onSelect: (option: TabOption) => void;
  activeTab?: string | number;
  contentPanelId: string;
  ariaDescription: string;
  dataEvent?: DataEventProp;
  isLoading?: boolean;
  fillWidth?: boolean;
};

export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_LEFT = 'ArrowLeft';
export const HOME = 'Home';
export const END = 'End';
export const ENTER = 'Enter';
export const SPACEBAR = ' ';
